import { VENDOR_CHANGE_PASSWORD, VENDOR_CHANGE_PASSWORD_SUCCESS, VENDOR_CHANGE_PASSWORD_ERROR, VENDOR_CHANGE_PASSWORD_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ChangeVendorPassword = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_CHANGE_PASSWORD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_CHANGE_PASSWORD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_CHANGE_PASSWORD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ChangeVendorPassword;
